<div
	[style.paddingLeft.px]="vm.segmentWidthPx/2"
	class="flex h-[56px] flex-row items-center justify-start gap-2 text-xs opacity-60"
>
	<div class="relative flex h-full flex-1 min-w-0">
		@for (seg of vm.segmentIndices; track seg) {
		<div
			[style.width.px]="vm.segmentWidthPx"
			class="relative h-full shrink-0"
		>
			@if (shouldShowHourLabel(seg)) {
			<span
				[class.left-0]="!isHourLabelAtEnd(seg)"
				[class.right-0]="isHourLabelAtEnd(seg)"
				[style.transform]="isHourLabelAtEnd(seg) ? 'translate(' + vm.hourLabelOffsetPx + 'px, -50%)' : 'translate(-' + vm.hourLabelOffsetPx + 'px, -50%)'"
				class="absolute top-1/2 whitespace-nowrap px-1 py-0.5"
			>
				{{ hourLabelForSegment(seg) | number: '2.0-0' }}:00
			</span>
			}
		</div>
		}
	</div>
</div>
